export default {
  SESSIONS: 'sessions'
};
